// Pydantic validation keys, SOURCE language. Partial by construction — the vocabulary is
// open; uncovered keys fall back to the response's English `message`.
export const EN_FIELD_ERRORS: Readonly<Record<string, string>> = {
  'validation.missing': 'Required field.',
  'validation.string_type': 'Must be text.',
  'validation.string_too_short': 'Too short: at least {min_length} characters.',
  'validation.string_too_long': 'Too long: at most {max_length} characters.',
  'validation.string_pattern_mismatch': 'Invalid format.',
  'validation.int_parsing': 'Must be a whole number.',
  'validation.int_type': 'Must be a whole number.',
  'validation.float_parsing': 'Must be a number.',
  'validation.bool_parsing': 'Must be true or false.',
  'validation.uuid_parsing': 'Invalid identifier.',
  'validation.date_parsing': 'Invalid date.',
  'validation.datetime_parsing': 'Invalid date and time.',
  'validation.greater_than': 'Must be greater than {gt}.',
  'validation.greater_than_equal': 'Must be at least {ge}.',
  'validation.less_than': 'Must be less than {lt}.',
  'validation.less_than_equal': 'Must be at most {le}.',
  'validation.enum': 'Value not allowed.',
  'validation.tax_code_invalid':
    'Check the codice fiscale: the last character does not match the other fifteen.',
  'validation.value_error': 'Invalid value.',
  'validation.iccid_checksum': 'Invalid ICCID: check the digits, one was misread.',
  'validation.router_code_format': 'Not a router code: scan the MAC on the label under the router.',
  'validation.sim_iccid_format':
    'Not a SIM’s ICCID: 19 or 20 digits starting with 89. Scan the barcode on the SIM card again.',
  'validation.too_short': 'At least {min_length} items are needed.',
  'validation.too_long': 'At most {max_length} items.',
}

/** Shown when the key is not covered and the response carries no `message`. */
export const EN_GENERIC_FIELD_ERROR = 'Invalid value.'
